import script from "./BuyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BuyDialog.vue?vue&type=style&index=0&id=63a9a30a&scoped=true&lang=css"

import exportComponent from "/var/www/html/laraccm2021/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9a30a"]])

export default __exports__